import React from "react";
import './Footer.css';

const Faq = () => {
    return (
        <div className="stuff-container">
            <h1 className="faq-page-title">FAQ</h1>
            <div className="items">
                <h4>Operating System</h4>
                <p>
                    My favorite distro is Slackware, but for compatibility reasons with modern software, and because nowadays I don't like
                    to be building stuff manually, I just use Ubuntu - <i>zero snap btw</i> -, and I still hope Canonical will bring back Unity
                    as the default DE again
                </p>
            </div>

            <div className="items">
                <h4>Text Editor</h4>
                <p>
                    I don't use an IDE. I've been using Vim since I was very young, so I kinda got used to it. And now I use Neovim, and with all
                    the plugins out there, there's no need to use any IDE, let alone a browser-based text editor like VS Code.
                    I don't like a lot of things on screen, like buttons everywhere, I enjoy things clean visually. But if I were to switch from Neovim, I'd
                    probably use the IDEs from JetBrains.
                </p>
            </div>

            <div className="items">
                <h4>Terminal Emulator</h4>
                <p>
                    I use kitty mainly because of the tabs feature, but recently I started using Tmux again, so I don't use those tabs anymore, but since
                    terminal emulators don't make any difference to me, I'll just keep using it.
                </p>
            </div>

            <div className="items">
                <h4>Font</h4>
                <p>JetBrains Mono all day</p>
            </div>

            <div className="items">
                <h4>Other stuff like browser, privacy...</h4>
                <p>
                    I use Brave, but being honest, I don't give a shit about privacy anymore. I used to care about it when I was young but eventually
                    you need to switch to proprietary software because of quality. For example, Firefox sucks when using Meet, the adblock I used and other
                    stuff like bookmarks didn't work well there.
                    <br />
                    I mean, most of the open-source software out there works just fine for an average user, but if you need to use these software for
                    work, it ain't going to work well most of the time.
                </p>
            </div>

            <div className="items">
                <h4>How to get in touch with me?</h4>
                <p>
                    You can mail me: <b>awkrenan@gmail.com</b> :) <br />
                </p>
            </div>

            <h4></h4>
        </div>
    )
}

export default Faq;
